import { useEffect, useState } from "react";
import "./InstallPrompt.css";

function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent;

    const mobileOrTablet =
      /Android|iPhone|iPad|iPod|Mobile|Tablet/i.test(ua);

    const ios =
      /iPad|iPhone|iPod/.test(ua);

    setIsIOS(ios);

    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone;

    if (!mobileOrTablet || isStandalone) {
      return;
    }

    const lastShown = localStorage.getItem("vortex-install");

    if (lastShown) {
      const diff =
        Date.now() - parseInt(lastShown);

      if (diff < 7 * 24 * 60 * 60 * 1000) {
        return;
      }
    }

    if (ios) {
      setShowBanner(true);
    }

    const handleInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowBanner(true);
    };

    window.addEventListener(
      "beforeinstallprompt",
      handleInstallPrompt
    );

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleInstallPrompt
      );
    };
  }, []);

  const installApp = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();

    const result =
      await deferredPrompt.userChoice;

    if (result.outcome === "accepted") {
      setShowBanner(false);
    }

    setDeferredPrompt(null);
  };

  const closeBanner = () => {
    localStorage.setItem(
      "vortex-install",
      Date.now().toString()
    );

    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="install-banner">
      <div className="install-content">
        <div className="install-title">
          ⚡ Install Vortex Network
        </div>

        <div className="install-text">
          Get faster access to Addons,
          Tutorials, Forums and Servers.
        </div>

        {isIOS ? (
          <div className="ios-steps">
            <p>
              1️⃣ Tap the Share button
            </p>
            <p>
              2️⃣ Select "Add to Home Screen"
            </p>
            <p>
              3️⃣ Tap "Add"
            </p>
          </div>
        ) : (
          <button
            className="install-btn"
            onClick={installApp}
          >
            Install App
          </button>
        )}

        <button
          className="later-btn"
          onClick={closeBanner}
        >
          Later
        </button>
      </div>
    </div>
  );
}

export default InstallPrompt;